import React from 'react';
import { Modal } from '../../../layout/modal';
import { ModalContent, ModalTitle } from '../../../layout/modal/content';
import { Button } from '../../../button';
import { OrderStatusItem } from '../changeStatusModal';
import { CommonText } from '../../../bumpViews/commonText';
export const OtherOptionsBoardModal = ({ isOpen, handleClose, handleDeleteOrders }) => {
    return (React.createElement(Modal, { active: isOpen, width: 542, close: handleClose, wrapperStyle: {
            fontFamily: 'Inter',
        } },
        React.createElement(ModalTitle, { className: "round-top text-center" },
            React.createElement("h3", null, "Other Options")),
        React.createElement(ModalContent, { style: { minHeight: '260px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' } },
            React.createElement(OrderStatusItem, { type: 'Cancelled', onClick: handleDeleteOrders, height: "60px" },
                React.createElement(CommonText, { size: "medium", weight: 600, color: "#F5F5F5" }, "Delete Orders")),
            React.createElement("div", null,
                React.createElement(Button, { type: "button", full: true, className: "m-r-2", onClick: handleClose }, "Cancel")))));
};
//# sourceMappingURL=index.js.map